<template>
  <simple-button
    v-p-t="20"
    v-p-b="20"
    v-f-size="'14px'"
    v-color:violet
    variant="transparent"
    @click="handleClick"
  >
    <base-icon v-m-r="10" name="basic_send" />
    <span v-text="$t('common.receipt')"></span>
  </simple-button>
</template>

<script>
import SimpleButton from 'molecules/common/SimpleButton';

import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'ReceiptSenderButton',
  components: {
    SimpleButton,
  },
  props: {
    description: String,
    payLink: {
      type: String,
      required: true,
    },
    publicId: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleClick() {
      EVENT_BUS.$emit('EVENT_SEND_TRANSACTION_RECEIPT', {
        url: this.payLink,
        title: `${this.$t('link.to.pay')} | capusta.space`,
        description: this.description,
        transactionId: this.publicId,
      });
    },
  },
};
</script>
